import customersPicture2 from 'assets/images/elena.png';
import haircareProductsHeroDesktop from 'assets/images/home_carousel_4_hero_d.jpg';
import haircareProductsHeroMobile from 'assets/images/home_carousel_4_hero_m.jpg';
import haircareProductsHeroTablet from 'assets/images/home_carousel_4_hero_t.jpg';
import badgeBackgroundImg from 'assets/images/landingPages/skincare/new-badge-background.svg';
import badgeRotatingImg from 'assets/images/landingPages/skincare/new-badge-rotated.svg';
import PressImg1 from 'assets/images/logo_bazaar_home.png';
import PressImg4 from 'assets/images/logo_bustle_home.png';
import PressImg3 from 'assets/images/logo_gq_home.png';
import PressImg2 from 'assets/images/logo_vogue_home.png';
import customersIllustrationMobile2 from 'assets/images/m-routine-elena.jpg';
import customersIllustrationMobile3 from 'assets/images/m-routine-macey.jpg';
import customersIllustrationMobile1 from 'assets/images/m-routine-natalie.jpg';
import customersPicture1 from 'assets/images/natalie.png';
import customersIllustrationDesktop2 from 'assets/images/routine-elena.jpg';
import customersIllustrationDesktop3 from 'assets/images/routine-macey.jpg';
import customersIllustrationDesktop1 from 'assets/images/routine-natalie.jpg';
import BcorpLogo from 'assets/images/skincare/b-corp-logo.png';
import brushDesktop from 'assets/images/skincare/brush-d.png';
import brushMobile from 'assets/images/skincare/brush-m.png';
import ClimateLogo from 'assets/images/skincare/climate-logo.png';
import aboutUsImgDesktop from 'assets/images/skincare/d-about-us.jpg';
import customHaircareImgDesktop from 'assets/images/skincare/d-haircare-hero.jpg';
import customSkincareHeroImageDesktop from 'assets/images/skincare/d-hero.jpg';
import haircareDesktop from 'assets/images/skincare/haircare-d.png';
import haircareMobile from 'assets/images/skincare/haircare-m.png';
import allProductsHeroDesktop from 'assets/images/skincare/home-hero-skincare-d.jpg';
import allProductsHeroMobile from 'assets/images/skincare/home-hero-skincare-m.jpg';
import aboutUsImgMobile from 'assets/images/skincare/m-about-us.jpg';
import customHaircareImgMobile from 'assets/images/skincare/m-haircare-hero.jpg';
import customSkincareHeroImageMobile from 'assets/images/skincare/m-hero.jpg';
import skincareDesktop from 'assets/images/skincare/skincare-d.png';
import skincareMobile from 'assets/images/skincare/skincare-m.png';
import skincareProductsHeroDesktop from 'assets/images/skincare/skincare-stack-hero-d.jpg';
import skincareProductsHeroMobile from 'assets/images/skincare/skincare-stack-hero-m.jpg';
import supplementsDesktop from 'assets/images/skincare/supplements-d.png';
import supplementsMobile from 'assets/images/skincare/supplements-m.png';
import SustainabilityImgDesktop from 'assets/images/skincare/sustainability-d.jpg';
import SustainabilityImgMobile from 'assets/images/skincare/sustainability-m.jpg';
import customersPicture3 from 'assets/images/t.png';
import UgcImgDesktop from 'assets/images/ugc_desktop.jpg';
import UgcImgMobile from 'assets/images/ugc_mobile.jpg';
import UgcImgTablet from 'assets/images/ugc_tab.jpg';

export const dataJsonLd = {
  '@context': 'http://schema.org',
  '@type': 'Organization',
  name: 'Prose',
  url: 'https://prose.com',
  logo: 'https://prose.com/logo.jpg',
  sameAs: ['https://www.facebook.com/prosehair', 'https://www.instagram.com/prose'],
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Brooklyn',
    postalCode: '11249',
    addressRegion: 'NY',
    streetAddress: '10 Grand Street',
  },
};

export const heroContent = () => ({
  backgroundDesktop: haircareProductsHeroDesktop,
  backgroundMobile: haircareProductsHeroMobile,
  backgroundTablet: haircareProductsHeroTablet,
  imageAlt:
    'Prose custom hair care and supplements displayed on natural bar soaps from left to right: Custom Scalp Mask, Custom Shampoo, Custom Conditioner and Root Source, Hair Supplements for scalp balance, healthy hair and hair growth.',
  title: (
    <>
      Transform your hair
      <br />
      with custom care
    </>
  ),
  subtitle: 'Discover your fully personalized routine, from shampoo to supplements',
  cta: {
    component: 'Cta',
  },
});

export const heroContentSkincare = {
  hasHaircareConsultationComplete: {
    backgroundDesktop: skincareProductsHeroDesktop,
    backgroundDesktopObjectPosition: '33% 50%',
    backgroundMobile: skincareProductsHeroMobile,
    backgroundTablet: skincareProductsHeroDesktop,
    imageAlt:
      'Prose custom skin care products stacked on top of each other in the following order from top to bottom: custom serum, custom cleanser and custom moisturizer.',
    title: 'Because your skin deserves custom care, too',
    subtitle:
      'Made-to-order formulas for bringing out your healthiest skin — so you can embrace what makes you uniquely you.',
    cta: {
      component: 'Cta',
    },
  },
  hasSkincareConsultationComplete: {
    backgroundDesktop: haircareProductsHeroDesktop,
    backgroundMobile: haircareProductsHeroMobile,
    backgroundTablet: haircareProductsHeroTablet,
    imageAlt:
      'Prose custom hair care and supplements displayed on natural bar soaps from left to right: Custom Scalp Mask, Custom Shampoo, Custom Conditioner and Root Source, Hair Supplements for scalp balance, healthy hair and hair growth.',
    title: 'Because your hair deserves custom care, too',
    subtitle: 'Discover your fully personalized routine, from shampoo to supplements',
    cta: {
      component: 'Cta',
    },
  },
  isDefault: {
    backgroundDesktop: allProductsHeroDesktop,
    backgroundMobile: allProductsHeroMobile,
    backgroundTablet: allProductsHeroMobile,
    imageAlt:
      'Prose Custom Shampoo stacked vertically on top of Prose Custom Scalp Mask next to Prose Custom Conditioner. On the right side, Prose custom skincare routine which include a face wash, serum and face cream.',
    title: 'Transform your hair and skin with custom care',
    subtitle: 'Made-to-order formulas designed to be one-of-a-kind — just like you.',
    cta: {
      component: 'Cta',
    },
  },
};

export const ticker = [
  'paraben free',
  'sulfate free',
  'phthalate free',
  'free of mineral oils',
  'free of GMOs',
  'cruelty-free',
  'carbon neutral',
];

export const aboutUs = {
  title: 'The only beauty standards that matter are your own',
  description: (
    <>
      Every product is the result of lab innovation, targeted personalization, and proven-effective
      ingredients — for always-improving results and progress that’s unique to you.
    </>
  ),
  cta: 'about us',
  imageDesktop: aboutUsImgDesktop,
  imageMobile: aboutUsImgMobile,
};

export const howItWorks = {
  title: 'How it works',
  primaryTitle: 'Think of us as your partner in haircare',
  description: ' We’ll work together to continually improve your hair—and your Prose.',
  instructions: [
    {
      label: (
        <>
          Easy online <br />
          consultation
        </>
      ),
      description:
        'In a few simple questions, we synthesize a myriad of factors around your hair, lifestyle, and preferences to find exactly what your hair needs',
    },
    {
      label: (
        <>
          A fully custom
          <br /> routine
        </>
      ),
      description:
        'We find the products you actually need, then customize each one for a perfect fit. Each one’s made with clean ingredients and bottled fresh to order',
    },
    {
      label: (
        <>
          Review & Refine<sup>®</sup>
          <br />
          your formulas
        </>
      ),
      description: (
        <>
          After receiving each order from Prose, tell us how your custom products perform by rating
          and reviewing each one. Prose will work to tailor your formulas for your next order to
          increase your satisfaction for always-improving results. Prose counts 5-star reviews on a
          per product basis, and includes 5-star reviews from first-time orders and from reviews of
          subsequent orders following a customer’s feedback in the Review & Refine<sup>®</sup>{' '}
          survey. When a customer is repeatedly satisfied, and submits another 5-star review, Prose
          counts that review as well - our goal is to constantly improve and to keep our customers
          happy!
        </>
      ),
    },
  ],
};

export const customersSkincare = {
  title: 'Testimonials from real Prose customers',
  customers: [
    {
      quote:
        '“I really love the way my hair feels since using Prose! It’s healthier and softer and I really love how it smells!”',
      name: 'Nathalie',
      description: 'Her routine includes:',
      usedProducts: 'The Core Trio — Curl Cream',
      picture: customersPicture1,
      routineIllustration: customersIllustrationDesktop1,
      routineIllustrationMobile: customersIllustrationMobile1,
    },
    {
      quote:
        '“This is the best hair care I’ve ever had in my life. Game changer. Will never look back at other shampoo!”',
      name: 'Elena',
      description: 'Her routine includes:',
      usedProducts: 'Shampoo — Conditioner',
      picture: customersPicture2,
      routineIllustration: customersIllustrationDesktop2,
      routineIllustrationMobile: customersIllustrationMobile2,
    },
    {
      quote:
        '“I love all the products that I have tried. They all have contributed to great volume, shine and curl.”',
      name: 'T',
      description: 'Her fuss-free routine includes:',
      usedProducts: 'The Core Trio — Dry Shampoo.',
      picture: customersPicture3,
      routineIllustration: customersIllustrationDesktop3,
      routineIllustrationMobile: customersIllustrationMobile3,
    },
  ],
  ctaLabel: 'read more reviews',
};

export const press = {
  title: 'in the press',
  quotes: [
    {
      quote: '“Prose is revolutionizing hair care with custom, made-to-order formulas…”',
      logo: PressImg1,
      alt: 'bazaar logo',
    },
    {
      quote: '“Taking tailored treatments to the next level...”',
      logo: PressImg2,
      alt: 'vogue logo',
    },
    {
      quote: '“Winner of Bespoke Styler award, GQ Grooming Awards 2019”',
      logo: PressImg3,
      alt: 'gq logo',
    },
    {
      quote: "“Prose's custom dry shampoo is certainly a product to test for yourself”",
      logo: PressImg4,
      alt: 'bustle logo',
    },
  ],
};

export const ugc = {
  title: 'This is what beauty looks like',
  secondaryTitle: 'prosebeauty',
  image: UgcImgDesktop,
  imageT: UgcImgTablet,
  imageM: UgcImgMobile,
  alt: 'A collage of Prose products and people using Prose products',
};

export const customHaircare = {
  imageAlt: 'women-closup-hair',
  imageMobile: customHaircareImgMobile,
  imageDesktop: customHaircareImgDesktop,
  title: 'For your hair',
  primaryTitle: 'Custom haircare',
  description:
    'From shampoo to supplements, every personalized formula is powered by natural actives to bring out your best, healthiest hair.',
  cta: {
    label: 'explore haircare',
    path: '/products/haircare',
  },
};

export const customSkincare = {
  imageAlt: 'women-closup-skin',
  imageMobile: customSkincareHeroImageMobile,
  imageDesktop: customSkincareHeroImageDesktop,
  title: 'NEW! FOR YOUR FACE',
  primaryTitle: 'Custom skincare',
  description:
    'Dermatologist-developed, clinically tested, and formulated with highly efficacious ingredients for all combinations of skin concerns.',
  cta: {
    label: 'explore skincare',
    path: '/pages/skincare',
  },
  badgeBackground: {
    src: badgeBackgroundImg,
    alt: '',
  },
  badgeRotatingContent: {
    src: badgeRotatingImg,
    alt: '',
  },
};

export const exploreMoreContent = {
  title: 'Explore more',
  primaryTitle: 'Go custom, never look back ',
  images: [
    {
      dataClick: 'haircare',
      dataFrom: 'category-selection',
      desktop: haircareDesktop,
      mobile: haircareMobile,
      category: 'haircare',
      path: '/products/haircare',
      isNew: false,
    },
    {
      dataClick: 'skincare',
      dataFrom: 'category-selection',
      desktop: skincareDesktop,
      mobile: skincareMobile,
      category: 'skincare',
      path: '/pages/skincare',
      isNew: true,
    },

    {
      dataClick: 'supplements',
      dataFrom: 'category-selection',
      desktop: supplementsDesktop,
      mobile: supplementsMobile,
      category: 'supplements',
      path: '/pages/supplements',
      isNew: false,
    },
    {
      dataClick: 'accessories',
      dataFrom: 'category-selection',
      desktop: brushDesktop,
      mobile: brushMobile,
      category: 'accessories',
      path: '/products/accessories',
      isNew: false,
    },
  ],
};

export const sustainability = {
  title: 'Putting sustainability first',
  description: (
    <>
      As a certified B-corporation, we’re big on transparency. From carbon-neutral production to
      sustainable sourcing, we do anything (and everything) to leave people and the planet better
      than we found them.
    </>
  ),
  imageDesktop: SustainabilityImgDesktop,
  imageMobile: SustainabilityImgMobile,
  imageAlt: 'girl-face-skin-close-up',
  logos: {
    bCorp: BcorpLogo,
    climate: ClimateLogo,
  },
  cta: {
    label: 'learn more',
    path: '/sustainability-and-social-impact',
    dataClick: 'sustainability',
    dataFrom: 'sustainability',
  },
};
